module.exports = __webpack_public_path__ + "static/media/authorization_login_error.d9061a30.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/developerApi/developerSdk/Authentication/authorization_login_error.png
// module id = 1220
// module chunks = 0